import { createContext, createElement, useContext } from 'react';
import isPropValid from '@emotion/is-prop-valid';
import type { DefaultTheme } from 'goober';
import { setup } from 'goober';
import { prefix } from 'goober/prefixer';
import { shouldForwardProp } from 'goober/should-forward-prop';

import { animations, duration, easing } from '@/theme/animations';
import {
  brandPalette,
  colors,
  componentsPalette,
  productPalette,
} from '@/theme/colors';

import type { BreakpointKey, MediaQueryType } from '@/theme/breakpoints';
import { breakpoints } from '@/theme/breakpoints';
import { mixins } from './mixins';
import { shadow } from './shadow';
import { fonts, typography } from './typography';

export const theme: DefaultTheme = {
  animations,
  breakpoints,
  colors,
  duration,
  easing,
  fonts,
  mixins,
  palettes: {
    brand: brandPalette,
    product: productPalette,
    component: componentsPalette,
  },
  shadow,
  typography,
};

const ThemeContext = createContext(theme);
const useTheme = () => useContext(ThemeContext);

export const mediaQuery = (
  breakpoint: BreakpointKey,
  type: MediaQueryType = 'min',
) => {
  return `@media (${type}-width: ${breakpoints[breakpoint]}px)`;
};

setup(createElement, prefix, useTheme, shouldForwardProp(isPropValid));
